import { render, staticRenderFns } from "./DictModal.vue?vue&type=template&id=1fcdf036&scoped=true"
import script from "./DictModal.vue?vue&type=script&lang=js"
export * from "./DictModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcdf036",
  null
  
)

export default component.exports